import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Page from "./Components/Page";
import PrivacyPage from "./Components/PrivacyPage";
import SupportPage from "./Components/SupportPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/*" element={<Page />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
